import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/globalGallery',
            name: 'village_globalGallery',
            component: () => import("./views/globalGallery.vue"),
            meta: {
                hideTopCut: true,
                showMembership: true,
            }
        },
    ];
};